import axios from '@/resources/libs/axios'

export default {
	//Logs

	setDocumentActionLog(data) {
		return axios.get(`/gei/logs/create`, { params: data })
	},

	downloadAllDocuments(data) {
		return axios.get(`/gei/download/alldocuments`, {
			params: data,
			responseType: "blob",
		})
	}


}